module.exports = __webpack_public_path__ + "img/cart-item-arrow.c7b10d88.svg";